// extracted by mini-css-extract-plugin
module.exports = {"linkedin":"Linkedin-module--linkedin--je0zA"};